module.exports = __webpack_public_path__ + "static/media/Glitch-5.2d874012.webp";